import type { RowAction } from "./explorerActions";

/**
 * The members table's action model (sibling to utils/explorerActions.ts,
 * built on the same `RowAction` contract): a member row's per-row menu
 * (three-dots, right-click, Shift+F10) and the toolbar's "Actions"
 * dropdown over the current selection are both built from this same list,
 * so the two menus cannot drift apart, same pattern as the file explorer.
 */
export function resetPasswordAction(onSelect: () => void): RowAction {
  return { key: "reset-password", type: "resetPassword", label: "Reset password", onSelect };
}

export function removeAction(onSelect: () => void): RowAction {
  return { key: "remove", type: "remove", label: "Remove", onSelect };
}
